import { render } from "./MengikutCaraBayaran.vue?vue&type=template&id=74545c84"
import script from "./MengikutCaraBayaran.vue?vue&type=script&lang=js"
export * from "./MengikutCaraBayaran.vue?vue&type=script&lang=js"

import "./MengikutCaraBayaran.vue?vue&type=style&index=0&id=74545c84&lang=css"
import "./MengikutCaraBayaran.vue?vue&type=style&index=1&id=74545c84&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__